import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import WeeksConversionLeadTimeLabel from './WeeksConversionLeadTimeLabel';
//import './InventoryLeadTimeLabel.scss';
import { leadTimeInDaysCutoff } from './leadTimeCalculator';
import StockRunLeadTimeLabel from './StockRunLeadTimeLabel';

const InventoryLeadTimeLabel = ({ leadTime, showConversionInBrackets }) => {
  return (
    <Fragment>
      {leadTime.inStock && (
        <span className="inventory-item-lead-time">
          {leadTime.numberOfDays === 1 && 'Next day'}
          {leadTime.numberOfDays !== 1 &&
            (leadTime.numberOfDays <= leadTimeInDaysCutoff ||
              showConversionInBrackets) &&
            `${leadTime.numberOfDays} days`}
          {showConversionInBrackets &&
            leadTime.numberOfDays > leadTimeInDaysCutoff && (
              <Fragment>
                {' '}
                (
                {
                  <WeeksConversionLeadTimeLabel
                    leadTimeDays={leadTime.numberOfDays}
                  />
                }
                )
              </Fragment>
            )}
          {!showConversionInBrackets &&
            leadTime.numberOfDays > leadTimeInDaysCutoff && (
              <WeeksConversionLeadTimeLabel
                leadTimeDays={leadTime.numberOfDays}
                roundToNearestWeek={true}
              />
            )}
        </span>
      )}
      {!leadTime.inStock && (
        <StockRunLeadTimeLabel
          minimumNumberOfDays={leadTime.minimumNumberOfDays}
          availableOn={leadTime.availableOn}
        />
      )}
    </Fragment>
  );
};

InventoryLeadTimeLabel.propTypes = {
  leadTime: PropTypes.shape({
    numberOfDays: PropTypes.number.isRequired,
    inStock: PropTypes.bool.isRequired,
    availableOn: PropTypes.string.isRequired,
    minimumNumberOfDays: PropTypes.number.isRequired,
  }).isRequired,
  showConversionInBrackets: PropTypes.bool,
};

InventoryLeadTimeLabel.defaultProps = {
  showConversionInBrackets: false,
};

export default InventoryLeadTimeLabel;
